import React, { ComponentPropsWithoutRef } from 'react';
import { Typography } from '@rbx/ui';
import useMarkdownStrongStyles from './MarkdownStrong.styles';

export type MarkdownStrongProps = ComponentPropsWithoutRef<'strong'>;

export default function MarkdownStrong({ children, ...otherProps }: MarkdownStrongProps) {
  // TODO: https://jira.rbx.com/browse/CRK-830
  // Replace this with 'body1/bold' variant in migration
  const {
    classes: { lineHeightAdjustment },
  } = useMarkdownStrongStyles();
  return (
    <Typography
      {...otherProps}
      display='inline'
      variant='largeLabel2'
      color='inherit'
      className={lineHeightAdjustment}>
      {children}
    </Typography>
  );
}
